/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   7/16/21
 */

import React from "react";
import {Box, Stack, useTheme} from "@mui/material";
import {borderedSx, cellSx, fixedSx, lastOfTypeX, todaySx, weekendSx} from "./sx";
import {isToday, isWeekend} from "date-fns";
import {format} from "../dates-helper";

export interface HeaderProps {
	intervals: Date[]
	formats: (string|string[])[]
	intervalWidth: number
	rangeResolution: number
}


export default function Header({intervals, formats, intervalWidth, rangeResolution}: HeaderProps) {

	const theme = useTheme();

	return (
		<Stack direction={"row"} sx={{ width: "fit-content" }}>
			<Box sx={{ ...fixedSx(theme), ...borderedSx(theme), borderTop: 0, borderLeft: 0, zIndex: 200 }}>

			</Box>
			<Stack>
				{formats.map(f =>
				<Stack key={JSON.stringify(f)} direction={"row"}>
					{intervals.map(d =>
						<Box
							key={d.toISOString()}
							sx={{
								...cellSx,
								minWidth: intervalWidth,
								maxWidth: intervalWidth,
								...borderedSx(theme),
								...lastOfTypeX(theme),
								...(rangeResolution < 1 && isWeekend(d) ? weekendSx(theme) : {}),
								...(rangeResolution < 1 && isToday(d) ? todaySx(theme) : {}),
							}}
						>
							{(!Array.isArray(f) ? [f]:f).map((p) =>
								<Stack key={p}>{format(d, p)}</Stack>
							)}
						</Box>
					)}
				</Stack>)}
			</Stack>
		</Stack>
	);

}